import { animate, state, style, transition, trigger } from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
  state('void', style({ opacity: 0 })),
  transition(':enter', [style({ opacity: 0 }), animate('400ms ease-in', style({ opacity: 1 }))]),
  transition(':leave', [animate('400ms ease-in', style({ opacity: 0 }))])
]);

export const slideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({ transform: 'translateX(+100%)' }),
    animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
  ])
]);

export const imageAnimation = trigger('imageAnimation', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.8)' }),
    animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
  ]),
  transition(':leave', [animate('200ms ease-in', style({ opacity: 0, transform: 'scale(0.8)' }))])
]);
